import { toast } from '@prophecy/ui-v3/Toast';
import { useState } from 'react';

import { TermsDecision, TermsResponseStatus } from '../../../data/apis/terms';
import { SapAiTermsTestIds } from '../constants';
import { useSapAiTermsGate } from '../hooks/useSapAiTermsGate';
import { downloadSapAiTerms } from '../Pdf/downloadSapAiTerms';
import { useSapAiTermsDialog } from '../sapAiTermsDialogContext';
import { showSapAiTermsAcceptedToast } from '../Toast/SapAiTermsSuccessToast';
import { SapAiTermsDialog } from './SapAiTermsDialog';

export function SapAiTermsPrompt() {
  const { recordDecision, shouldPromptOnLogin } = useSapAiTermsGate();
  const { isOpen: isOpenedFromCta, closeDialog } = useSapAiTermsDialog();
  const [isDismissed, setIsDismissed] = useState(false);

  const isOpen = isOpenedFromCta || (shouldPromptOnLogin && !isDismissed);

  const onDecision = async (decision: TermsDecision) => {
    let record;
    try {
      record = await recordDecision(decision);
    } catch {
      // The response is the compliance record, so a failed write must leave the dialog up rather
      // than let the admin walk away believing they accepted.
      toast.error({
        content: 'Could not record your response. Please try again.',
        'data-test-id': SapAiTermsTestIds.decisionErrorToast
      });
      return;
    }

    setIsDismissed(true);
    closeDialog();

    if (decision === TermsResponseStatus.accepted && record.status === TermsResponseStatus.accepted) {
      showSapAiTermsAcceptedToast(record.respondedAt ?? new Date().toISOString());
      return;
    }

    if (record.status !== decision) {
      toast.info({
        content: 'These AI terms have already been accepted for your organization.',
        'data-test-id': SapAiTermsTestIds.alreadyAcceptedToast
      });
    }
  };

  if (!isOpen) return null;

  return <SapAiTermsDialog open onDecision={onDecision} onDownloadTerms={downloadSapAiTerms} />;
}
